'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "emojiSize", "perLine", "popoverProps", "PickerContent", "autoFocus"];
import { Component } from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { jsx as _jsx } from "react/jsx-runtime";
export default class EmojiPickerWrapper extends Component {
  constructor(...args) {
    super(...args);
    this.setPickerContentRef = c => {
      this.pickerContent = c;
    };
    this.focus = () => {
      if (this.pickerContent) this.pickerContent.focus();
    };
  }
  componentDidUpdate(prevProps) {
    if (this.props.autoFocus && !prevProps.popoverProps.open && this.props.popoverProps.open) {
      setTimeout(this.focus);
    }
  }
  render() {
    const _this$props = this.props,
      {
        children,
        emojiSize,
        perLine,
        popoverProps,
        PickerContent
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    // width calculation borrowed from emoji-mart
    const pickerWidth = popoverProps && popoverProps.width || perLine * (emojiSize + 12) + 12 + 2 + 30;
    return /*#__PURE__*/_jsx(Popover, Object.assign({}, popoverProps, {
      content: /*#__PURE__*/_jsx(PickerContent, Object.assign({
        ref: this.setPickerContentRef
      }, rest)),
      inlineSize: pickerWidth,
      children: children
    }));
  }
}
EmojiPickerWrapper.propTypes = {
  children: PropTypes.node,
  emojiSize: PropTypes.number,
  perLine: PropTypes.number,
  showSkinTones: PropTypes.bool,
  popoverProps: PropTypes.object,
  unicodeVersion: PropTypes.number,
  customEmojiFilter: PropTypes.func,
  useDefaultFilter: PropTypes.bool,
  storeHandlers: PropTypes.shape({
    getter: PropTypes.func,
    setter: PropTypes.func
  }),
  PickerContent: PropTypes.elementType.isRequired,
  autoFocus: PropTypes.bool
};
EmojiPickerWrapper.defaultProps = {
  emojiSize: 24,
  perLine: 7,
  showSkinTones: true,
  unicodeVersion: 8.0,
  useDefaultFilter: true
};